// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".warning-container {\n  display: flex;\n  justify-content: space-between;\n  width: 180px;\n  padding: 10px;\n  font-size: 12px;\n  font-weight: 600;\n  background-color: #fcedd3;\n  box-sizing: border-box;\n}\n\n.warning-message {\n  width: 130px;\n}\n", ""]);
// Exports
module.exports = exports;
